import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 90);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-9 border-b border-background-200/80 text-[11px] font-label tracking-[0.18em] text-foreground-500">
          <span>2026 年 09 月 10 日 · 星期四</span>
          <span className="hidden md:inline">深挖 · 求证 · 还原</span>
          <span className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse-dot" />
            正在跟随 12 起热点事件
          </span>
        </div>

        <div className={`flex items-center justify-between gap-6 transition-all duration-300 ${scrolled ? "py-3" : "py-5"}`}>
          <a href="/" className="flex items-end gap-3 shrink-0">
            <span className="flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg md:text-xl" />
            </span>
            <span className="leading-none">
              <h1
                className={`font-heading font-black tracking-tight text-foreground-950 transition-all duration-300 ${
                  scrolled ? "text-2xl md:text-3xl" : "text-3xl md:text-5xl"
                }`}
              >
                热点黑料
              </h1>
              <span className="hidden md:block mt-1 text-[10px] font-label tracking-[0.34em] text-foreground-400">
                HOTSPOT DEEP DIVE
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7 font-label text-sm text-foreground-700">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="link-underline whitespace-nowrap hover:text-primary-600 transition-colors">
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <button
              type="button"
              className="hidden sm:flex items-center justify-center w-9 h-9 rounded-full border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
              aria-label="搜索热点"
            >
              <i className="ri-search-line" />
            </button>
            <a
              href="#background"
              className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 h-9 text-sm font-label text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line" />
              资料下载
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden flex items-center justify-center w-9 h-9 rounded-md border border-background-300 text-foreground-700 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav className="lg:hidden pb-4 flex flex-wrap gap-x-6 gap-y-3 font-label text-sm text-foreground-700">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}